module.exports = __webpack_public_path__ + "img/overview1.56437245.png";